<template>
  <div class="px-2 auth">
    <div class="auth-left">
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form class="auth-login-form mt-2" @submit.prevent="login">
          <b-form-group class="text-center"
            ><h4 class="text-success font-weight-bolder">
              {{ $t("REGISTRATION") }}
            </h4></b-form-group
          >
               <!-- email -->
               <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="required|email"
            >
              <label class="pl-1">
                {{ $t("email") }}<span class="required">*</span> (eg.:
                joe@xyz.com)</label
              >
              <b-form-input
                v-model="user.email"
                class="round"
                autofocus

                :state="errors.length > 0 ? false : null"
                :placeholder="$t('enterEmail')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          <!-- email -->
          <!-- email -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Company name"
              rules="required"
            >
              <label class="pl-1">
                {{ $t("companyName") }}<span class="required">*</span>
              </label>

              <b-form-input
                v-model="user.companyName"
                class="round"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('enterCompanyName')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          <!-- email -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Contact name"
              rules="required"
            >
              <label class="pl-1"
                >{{ $t("contactName") }}<span class="required">*</span></label
              >
              <b-form-input
                v-model="user.fullName"
                class="round"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('placeholderName')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          <!-- email -->
          <!-- email -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Tax Code"
              rules="required"
            >
              <label class="pl-1">
                {{ $t("taxCode") }}<span class="required">*</span></label
              >
              <b-form-input
                v-model="user.taxCode"
                class="round"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('enterTaxCode')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Address"
              rules=""
            >
              <label class="pl-1">
                {{ $t("address") }}</label
              >
              <b-form-input
                v-model="user.companyAddress"
                class="round"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('enterAddress')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          

          <label v-show="false" class="pl-1">
            {{ $t("gender") }}</label
          >
          <b-form-group class="pl-1 pt-1" v-show="false">
            <b-row>
              <b-col cols="4">
                <b-form-radio
                  v-model="user.genderId"
                  name="some-radios"
                  value="1"
                >
                  {{ $t("Male") }}
                </b-form-radio>
              </b-col>
              <b-col cols="4">
                <b-form-radio
                  v-model="user.genderId"
                  name="some-radios"
                  value="2"
                >
                  {{ $t("Female") }}
                </b-form-radio>
              </b-col>
            </b-row>
          </b-form-group>
          <!-- email -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Phone"
              rules="regex:^([0-9]+)$"
            >
              <label class="pl-1">
                {{ $t("phone") }} (Only
                Phone)</label
              >
              <b-form-input
                v-model="user.phone"
                class="round"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('placeholderPhone')"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
     

          <!-- checkbox -->
          <b-form-group>
            <span class="text-danger">{{ errMsg }}</span>
          </b-form-group>

          <!-- submit button -->
          <b-form-group class="text-center">
            <a
              class="font-weight-bolder h3 text-success"
              @click="register"
              :disabled="invalid"
              >{{ $t("register") }}</a
            >
          </b-form-group>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";

import VuexyLogo from "@core/layouts/components/Logo.vue";

import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import useJwt from "@/auth/jwt/useJwt";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    // BSV
    Select2,

    VuexyLogo,

    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: { genderId: 1 },
      bankItems: [],
      // validation rules

      errMsg: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {},
  methods: {
    register() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          useJwt
            .post("userListNoLogin", {
              registerInfo: JSON.stringify({ ...this.user }),
              ...this.user,
            })
            .then((response) => {
              if (
                response.data.result == "emailExists" ||
                response.data.result == "0"
              ) {
                return this.$swal({
                  icon: "warning",
                  html: `Email already exists. If you forgot your password <a href='/auth/forgot-password'>Click here</a>`,
                  focusConfirm: false,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }

              //               this.$toast({
              //                 component: ToastificationContent,
              //                 props: {
              //                   title: `WR1 team is processing customer information.
              // Please follow email or contact WR1 team directly with hotline (+84) 964 671 674!`,
              //                   icon: "CheckSquareIcon",
              //                   variant: "primary",
              //                 },
              //               });
              this.$router.replace({ name: "auth-login" });
              this.$swal({
                icon: "success",
                title: "Register success",
                text: "WR1 team is processing customer information. Please follow email or contact WR1 team directly with hotline (+84) 964 671 674!",
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select2-selection--single {
  border-radius: 50rem !important;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
.auth {
  display: flex;
  justify-content: center;
  margin-bottom: 200px;
}
.auth-left {
  width: 25%;

  @media (max-width: 900px) {
    padding: 10px;
    width: 100%;
  }
  @media (max-width: 768px) {
    padding: 10px;
    width: 80%;
  }
  @media (max-width: 1500px) {
    padding: 10px;
    width: 35%;
  }
}
</style>
